import { render, staticRenderFns } from "./l-tree.vue?vue&type=template&id=0b07617d&"
import script from "./l-tree.vue?vue&type=script&lang=js&"
export * from "./l-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports